import { Route } from '@direct-frontend/modules-router';
import { NewsAsync } from '#pages/news';
import { NewsEntry } from '#pages/newsEntry';
import { renderWithPermission } from '#shared/lib/managerPermissions';
import { newsItemRoute, newsRoute } from '#shared/lib/routes';

export const newsRoutes = () =>
    renderWithPermission(
        'news',
        'read',
        <>
            <Route path={newsRoute.route} element={<NewsAsync />} />
            <Route path={newsItemRoute.route} element={<NewsEntry />} />
        </>
    );
